import React, { Component } from 'react';
import SelectInput from 'Components/forms/select-input';
import { connect } from 'react-redux';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import './AppSelection.scss';
import { getSelectionList } from './configStructure';
import PropTypes from 'prop-types';
import { setDataSearchTrasactionGridProp, toggleAppSearchPanelAction, setRelatedGridLoadedAction } from 'Actions/toggleAppSearchPanelAction'


export class AppSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isSelections: false,
      selectedItem: null,
      selectList: [],
      defaultValue: { id: '0', value: 'search', text: 'Search' },
    };
    this.attachBindings();
  }

  attachBindings() {
    this.toggleSelections = this.toggleSelections.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
  }

  componentWillMount() {
    this.setState({
      selectList: getSelectionList(),
    });
  }
  // First load all filter related to id.
  componentDidMount() {
    scroll(0, 0);
  }
  toggleSelections = () => {
    this.setState({
      isSelections: !this.state.isSelections,
    });
  }

  updateSelection(value) {
    this.props.setDataSearchTrasactionGridProp(true, true, false)
    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    if (value !== null) {
      this.props.setSearchOpenFlag(true);
      this.props.toggleAppSearchPanelAction(false);
      this.props.setRelatedGridLoadedAction(false);
      const selectedOption = this.state.selectList.find((item) => item.value === value);
      if (this.state.selectedItem !== null && this.state.selectedItem.id == selectedOption.id) {
        this.props.setSearchType(null);
        this.setState({ selectedItem: this.state.defaultValue }, () => {
          this.props.setSearchType(selectedOption.id);
          this.setState({ selectedItem: selectedOption });
        });
      } else {
        this.setState({ selectedItem: selectedOption });
        this.props.setSearchType(selectedOption.id);
      }
    } else {
      this.setState({ selectedItem: null });
    }
  }


  render() {
    return (

      <div >
        {
          this.props.user && this.props.user.parsedPermissions && this.props.user.parsedPermissions.search &&
          this.props.user.parsedPermissions.search.dataSearch &&
          (
            <SelectInput
              dataList={this.state.selectList}
              selectClass={{
                color: '#262aff',
                marginLeft: '0px',
              }}
              handleSelection={this.updateSelection}
              promptText="Data Search <b style=color:#c4c4c4>CTRL+ALT+0</b>"
              id="selectDataSearch"
              wrapperClass="select-menu__form reports"
              promptOnly
              isAppSelection
            />
          )
        }
      </div>
    );
  }
}
AppSelection.propTypes = {
  setSearchType: PropTypes.func.isRequired,
};

AppSelection.defaultProps = {

};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    toggleAppSearchPanelAction: (isRelatedTransactionGridOpen) => {
      dispatch(toggleAppSearchPanelAction(isRelatedTransactionGridOpen));
    },
    setRelatedGridLoadedAction: (isRelatedTransactionGridLoaded) => {
      dispatch(setRelatedGridLoadedAction(isRelatedTransactionGridLoaded));
    },
    setDataSearchTrasactionGridProp: (dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage) => {
      dispatch(setDataSearchTrasactionGridProp(dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage));
    },
  };
};



export default connect(mapStateToProps, mapDispatchToProps)(AppSelection);
